import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import config, { SENTRY } from "./config";
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from "react-router-dom";

Sentry.init({
    dsn: SENTRY.dsn,
    environment: config.env,
    autoSessionTracking: true,
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        Sentry.replayIntegration(),
    ],
    sampleRate: SENTRY.sampleRate, // Scale from 0 to 1.0 (100% of error events)
    tracesSampleRate: SENTRY.tracesSampleRate, // Scale from 0 to 1.0 (100% of transactions)
    replaysSessionSampleRate: SENTRY.replaysSessionSampleRate, // Scale from 0 to 1.0 (100% of sessions)
    replaysOnErrorSampleRate: SENTRY.replaysOnErrorSampleRate, // Scale from 0 to 1.0 (100% of errors)
});